module.exports = __webpack_public_path__ + "static/media/sound.22d4303a.mp3";